import { AutoFocusModule } from '@app/infrastructure/directives/auto-focus/auto-focus.module';
import { PartnerConfirmLinkDeleteModalComponent } from '@modules/partner-portal/components/modals/partner-confirm-link-delete-modal/partner-confirm-link-delete-modal.component';
import { PartnerFinishOnboardingModalComponent } from '@modules/partner-portal/components/modals/partner-finish-onboarding-modal/partner-finish-onboarding-modal.component';
import { PartnerAddOrganizationModalComponent } from '@modules/partner-portal/components/modals/partner-add-organization-modal/partner-add-organization-modal.component';
import { PartnerOnboardAccountsModalComponent } from '@modules/partner-portal/components/modals/partner-onboard-accounts-modal/partner-onboard-accounts-modal.component';
import { PartnerReonboardAccoutModalComponent } from '@modules/partner-portal/components/modals/partner-reonboard-accout-modal/partner-reonboard-accout-modal.component';
import { PartnerSelectOrgUnitModalComponent } from '@modules/partner-portal/components/modals/partner-select-org-unit-modal/partner-select-org-unit-modal.component';
import { PartnerGenerateLinksModalComponent } from '@modules/partner-portal/components/modals/partner-generate-links-modal/partner-generate-links-modal.component';
import { OnboardingPermissionsTreeModule } from '@modules/shared/components/onboarding-permissions-tree/onboarding-permissions-tree.module';
import { ShellPartnersComponent } from '@app/shell-partners/shell-partners.component';
import { LayoutModule } from '@app/infrastructure/layout/layout.module';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';
import { MatStepperModule } from '@angular/material/stepper';
import { MatSelectModule } from '@angular/material/select';
import { MatButtonModule } from '@angular/material/button';
import { MatInputModule } from '@angular/material/input';
import { MatRadioModule } from '@angular/material/radio';
import { Ng2SearchPipeModule } from 'ng2-search-filter';
import { MatIconModule } from '@angular/material/icon';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { NgModule } from '@angular/core';

@NgModule({
	imports: [
		LayoutModule,
		MatProgressBarModule,
		FormsModule,
		Ng2SearchPipeModule,
		TooltipModule,
		MatFormFieldModule,
		ReactiveFormsModule,
		MatInputModule,
		NgxDatatableModule,
		MatRadioModule,
		MatSelectModule,
		MatStepperModule,
		MatIconModule,
		MatButtonModule,
		OnboardingPermissionsTreeModule,
		AutoFocusModule,
	],
	declarations: [
		ShellPartnersComponent,

		PartnerAddOrganizationModalComponent,
		PartnerConfirmLinkDeleteModalComponent,
		PartnerFinishOnboardingModalComponent,
		PartnerGenerateLinksModalComponent,
		PartnerOnboardAccountsModalComponent,
		PartnerReonboardAccoutModalComponent,
		PartnerSelectOrgUnitModalComponent,
	],
})
export class ShellPartnersModule {}
